import styled from 'styled-components';
import LoaderBase from './Skeletons/LoaderBase';

export default styled(LoaderBase)``;
